<template>
    <div class="slide-txt-container" ref="slidewrap" :style="{ marginLeft: slideleft, width: slideWidth, color: slideColor }">
        <div class="slide-in" ref='slide' :style="{left:left + 'px'}">
            <span v-for="(item,index) in showList" :key="index" v-html="item" :style="{ minWidth: slideWidth }"></span>
        </div>
    </div>
</template>

<script>
    // @ is an alias to /src
    import img from '@/assets/image/tanhao1.png'
    import commonData from '../plugins/FetchCommonData/'
    export default {
        name: 'Layout',
        data: () => ({
            list: [],
            left: 0,
            slideleft: "-219px",
            slideWidth: "854px",
            slideColor: "rgb(150, 194, 255)"
        }),
        methods: {
            initSlide() {
                let start = null,
                    self = this,
                    limitWidth = this.$refs.slide.offsetWidth / 2,
                    playFlag = true

                function step(timestamp) {
                    var curleft = self.left - 1
                    if (curleft <= -1 * limitWidth) {
                        self.left = 0
                    } else {
                        self.left = curleft
                    }
                    if (playFlag) window.requestAnimationFrame(step)
                }
                window.requestAnimationFrame(step)
                this.$refs.slidewrap.addEventListener('mouseenter', function () {
                    playFlag = false
                })
                this.$refs.slidewrap.addEventListener('mouseleave', function () {
                    playFlag = true
                    window.requestAnimationFrame(step)
                })
            }
        },
        computed: {
            showList() {
                if (this.list.length <= 0) return []
                return this.list.concat(this.list)
            }
        },
        watch: {
            showList: {
                handler(val) {
                    if (val.length > 0) {
                        this.$nextTick(_ => {
                            this.initSlide()
                        })
                    }
                },
                immediate: true
            },
            "$route": {
                handler (val) {
                    if (val.name == 'Home') {
                        this.slideleft = "-635px"
                        this.slideWidth = "1270px"
                        this.slideColor = "#808080"
                    } else {
                        this.slideleft = "-219px"
                        this.slideWidth = "854px"
                        this.slideColor = "rgb(150, 194, 255)"
                    }
                },
                immediate: true
            },
        },
        async mounted() {
            let wt9 = await commonData('appShortName_17')
            let wt8 = await commonData('appShortName_11')
            let wt7 = await commonData('appShortName_12')
            setTimeout(_ => {
                this.list = [
                    `<img src="${img}" />多账号下单功能、五档数据、境外实时数据需在购买${wt7}/${wt8}/${wt9}软件基础上另外选配。`
                ]
            })
        }
    }
</script>

<style scoped>
    .slide-txt-container {
        height: 36px;
        line-height: 26px;
        overflow: hidden;
        white-space: nowrap;
        cursor: default;
        font-size: 14px;
        font-family: 'Microsoft Yahei', Tahoma, Arial, Helvetica, Simsun, STHeiti;
        position: absolute;
        left: 50%;
        /* margin-left: -140px; */
        top: 0;
    }

    .slide-in {
        display: inline-block;
        position: absolute;
        left: 0;
        top: 10px;
    }

    .slide-in span {
        display: inline-block;
    }

    
    
</style>>